<template>
  <div class="product-list">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Input v-model="formItem.key"
                 clearable
                 placeholder="输入藏品名称或者藏家手机号查找..."
                 style="width:250px"></Input>
        </FormItem>
        <FormItem>
          <Button type="primary"
                  @click="renderTable('formItem')">查找</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table border
           :columns="list"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <Drawer :title="title"
            v-model="showModalStatus"
            width="1200"
            :mask-closable="false"
            :styles="styles">
      <Form :model="goods"
            :label-width="80">
        <Row>
          <Col span="8">
          <FormItem label="标题"
                    label-position="top">
            <Input v-model="goods.item_name"
                   placeholder="商品标题">></Input>
          </FormItem>
          </Col>
          <Col span="8">
          <FormItem label="分类"
                    label-position="top">
            <Input v-model="goods.catename"></Input>
          </FormItem>
          </Col>
          <Col span="8">
          <FormItem label="类型"
                    label-position="top">
            <Input v-model="goods.cate"></Input>
          </FormItem>
          </Col>

        </Row>
        <FormItem label="描述"
                  label-position="top"
                  prop="describe">
          <Input type="textarea"
                 v-model="goods.describe"
                 :rows="3"
                 placeholder="请输入描述" />
        </FormItem>
        <FormItem label="缩略图">
          <img :src="goods.thumb"
               style="width: 420px;height: 232px;" />
        </FormItem>
        <!-- <FormItem label="模型文件">
          <Input v-model="goods.model_file"></Input>
        </FormItem> -->
        <FormItem label="图集">
          <div class="upload-list"
               v-for="item in goods.attrShow"
               :key="item">
            <img :src="item" />
          </div>
        </FormItem>
      </Form>
    </Drawer>
  </div>
</template>

<script>
export default {
  name: 'product-list',
  data () {
    return {
      styles: {
        height: 'calc(100% - 55px)',
        overflow: 'auto',
        paddingBottom: '53px',
        position: 'static'
      },
      goods: {
        item_name: '',
        catename: '',
        type: "",
        describe: '',
        thumb: '',
        model_file: '',
      },
      editor: {
        ifno: '',
      },
      loading: true,
      dataloading: true,
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      title: '',
      formItem: {
        'key': '',
      },
      list: [
        {
          title: 'Id',
          key: 'id',
          fixed: 'left',
          width: 90
        },
        {
          title: '藏品',
          key: 'name',
          minWidth: 300,
          render: (h, params) => {
            return h('div', [
              h('p', {
                style: {
                  color: '#8a6d3b'
                }
              }, '项目名称:' + params.row.item_name),
              h('p', {
                style: {
                  color: '#777'
                }
              }, '哈希值:' + params.row.chain_blockchain_id)
            ]);
          }
        },
        {
          title: '藏家',
          key: 'collectordata',
          minWidth: 150,
          render: (h, params) => {
            return h('div', [
              h('p', {
                style: {
                  color: '#8a6d3b'
                }
              }, '姓名:' + params.row.collector_name),
              h('p', {
                style: {
                  color: '#8a6d3b'
                }
              }, '手机号:' + params.row.phone),
              h('p', {
                style: {
                  color: '#777'
                }
              }, 'uuid:' + params.row.collector_uuid)
            ]);
          }
        },
        {
          title: '类别',
          key: 'cate',
          minWidth: 150,
        },
        {
          title: '分类',
          key: 'type_name',
          minWidth: 80,
        },
        {
          title: '操作',
          key: 'action',
          width: 200,
          align: 'left',
          fixed: 'right',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                style: {
                  marginRight: '8px'
                },
                props: {
                  type: 'primary',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.detail(params.row.id)
                  }
                }
              }, '编辑')
            ]);

          }
        }
      ],
      tablelist: [],
      showModalStatus: false,
      id: 0,

    }
  },
  created: function () {
    this.getTableList();

  },
  components: {
  },

  methods: {
    getTableList: function () {
      this.$api.collectionchain.list({ "page": this.pages.page, "size": this.pages.size, 'status': 1 }).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    // 详情
    detail (id) {
      this.title = "编辑商品";
      this.showModalStatus = !this.showModalStatus;
      this.$api.collectionchain.detail({ id: id }).then(res => {
        this.goods = res.result;
      });
    },
    // 翻页
    changePage () {
      this.pages.page = this.$refs['listPage'].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function (name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = {
        key: this.formItem.key,
        page: this.pages.page,
        size: this.pages.size,
        status: 1
      };
      this.$api.collectionchain.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
  },
}
</script>
